import React from "react";
import "./group.css";
import { Camera } from "lucide-react";

const Header = ({ groupData }) => {
  return (
    <div className="header">
      <div className="page-header">
        <div className="group-banner" style={groupData?.banner_image ? { backgroundImage: `url(${groupData?.banner_image})` } : {}}>
          <div className="banner-content">
            {/* <div className="banner-heading">{groupData?.name}</div> */}
            {/* <div className="banner-subheading">
              Regular group • {groupData?.members.length} members
            </div> */}
            {/* <button className="banner-button">
              <span className="banner-button-icon">
                <Camera
                  style={{ width: "1rem", height: "1rem", marginLeft: "1rem" }}
                />
              </span>
              <span className="banner-button-label">Add Banner</span>
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
